import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { ArrowLeft, TrendingUp, Eye, CheckCircle2, Lock, Flame, Crown, Award } from "lucide-react";

const CRITERIA = [
  { label: "1,000+ Followers", icon: "👥" },
  { label: "10,000+ Total Views", icon: "👁️" },
  { label: "30+ Days Account Age", icon: "📅" },
  { label: "5+ Reels Uploaded/Month", icon: "📹" },
  { label: "No Community Violations", icon: "🛡️" },
];

export default function Monetization() {
  const [viral, setViral] = useState(null);

  useEffect(() => { api.get("/users/me/viral-stats").then(r => setViral(r.data)); }, []);

  return (
    <div className="px-4 py-6">
      <div className="flex items-center gap-3 mb-3">
        <Link to="/settings"><ArrowLeft className="w-5 h-5"/></Link>
        <h1 className="font-outfit font-extrabold text-2xl tracking-tighter">Monetization</h1>
      </div>
      <p className="text-white/60 text-sm mb-5">Track your eligibility • Earn from your content</p>

      {/* Go Viral Tracker */}
      <div className="rounded-3xl p-5 bg-gradient-to-br from-[#FF2A5F]/15 via-[#FF7A00]/10 to-[#00E5FF]/10 border border-[#FF7A00]/30 mb-5" data-testid="viral-tracker">
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-2">
            <Flame className="w-5 h-5 text-[#FF2A5F]"/>
            <h2 className="font-outfit font-extrabold text-lg">Go Viral Path</h2>
          </div>
          {viral?.is_qualified ? (
            <span className="px-2 py-0.5 rounded-full bg-emerald-500/20 text-emerald-400 text-[10px] font-bold uppercase">Qualified ✓</span>
          ) : (
            <span className="px-2 py-0.5 rounded-full bg-[#FF7A00]/15 text-[#FF7A00] text-[10px] font-bold uppercase">In Progress</span>
          )}
        </div>
        <p className="text-xs text-white/80 mb-3">Get <b className="text-[#FF7A00]">5 reels each crossing 1 lakh (1,00,000) views</b> to unlock priority monetization status.</p>
        {viral && (
          <>
            <div className="flex justify-between text-[10px] text-white/60 mb-1">
              <span>Progress</span>
              <span>{viral.viral_reels} / {viral.viral_target} viral reels</span>
            </div>
            <div className="h-3 bg-white/10 rounded-full overflow-hidden mb-3">
              <div className="h-full bg-gradient-to-r from-[#FF2A5F] via-[#FF7A00] to-[#00E5FF]" style={{width: `${viral.progress_pct}%`}}/>
            </div>
            {viral.viral_list && viral.viral_list.length > 0 && (
              <div className="mt-2">
                <div className="text-[10px] text-white/60 uppercase tracking-wide mb-1.5">Your Viral Reels</div>
                {viral.viral_list.map(r => (
                  <div key={r.id} className="flex items-center justify-between text-xs py-1.5 border-t border-white/10">
                    <span className="truncate flex-1">{r.title}</span>
                    <span className="text-[#FF7A00] flex items-center gap-1"><Eye className="w-3 h-3"/>{r.views.toLocaleString()}</span>
                  </div>
                ))}
              </div>
            )}
            <div className="text-[10px] text-white/60 mt-2 text-center">{viral.total_reels} total reels uploaded</div>
          </>
        )}
      </div>

      {/* Standard Criteria */}
      <h3 className="font-outfit font-bold text-lg mb-2 flex items-center gap-2"><Crown className="w-4 h-4 text-[#FF7A00]"/>Standard Eligibility</h3>
      <p className="text-xs text-white/70 mb-3">Alternative path to monetization (any 1 of these qualifies you):</p>
      <div className="space-y-2 mb-5" data-testid="criteria-list">
        {CRITERIA.map(c => (
          <div key={c.label} className="p-3 rounded-2xl bg-white/5 border border-white/10 flex items-center gap-3">
            <div className="text-2xl">{c.icon}</div>
            <div className="flex-1 text-sm">{c.label}</div>
            <Lock className="w-4 h-4 text-white/30"/>
          </div>
        ))}
      </div>

      <div className="p-4 rounded-2xl bg-[#FF7A00]/10 border border-[#FF7A00]/30 flex gap-3">
        <Award className="w-5 h-5 text-[#FF7A00] flex-shrink-0 mt-0.5"/>
        <div>
          <p className="text-sm font-semibold mb-1">💰 Monetization activation in Phase 2</p>
          <p className="text-xs text-white/80">Razorpay payouts, ad revenue share, and creator fund will activate once minimum platform user base is reached. Stay active and qualified — early eligibility = priority access.</p>
        </div>
      </div>
    </div>
  );
}
